(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const initializeProductCardHoverGalleries = (scope = document) => {
    scope.querySelectorAll('[data-hover-gallery]').forEach((gallery) => {
      if (gallery.dataset.hoverGalleryReady === 'true') return;

      gallery.dataset.hoverGalleryReady = 'true';
      gallery.dataset.hoverGalleryIndex = '0';

      const selectImage = (requestedIndex) => {
        const slideshow = gallery.querySelector('slideshow-component');
        const slides = Array.from(slideshow?.querySelectorAll('slideshow-slide') ?? []).slice(0, 3);
        const dots = Array.from(gallery.querySelectorAll('[data-hover-gallery-dot]'));
        const index = Math.min(requestedIndex, slides.length - 1, dots.length - 1);

        if (index < 0 || Number(gallery.dataset.hoverGalleryIndex) === index) return;
        if (!slideshow || typeof slideshow.select !== 'function') return;

        const slideId = slides[index]?.getAttribute('slide-id');
        if (!slideId) return;

        gallery.dataset.hoverGalleryIndex = String(index);
        slideshow.select({ id: slideId }, undefined, { animate: false });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      gallery.addEventListener('slideshow:select', (event) => {
        const dots = Array.from(gallery.querySelectorAll('[data-hover-gallery-dot]'));
        if (dots.length < 2) return;

        const index = Math.min(event.detail.index, dots.length - 1);
        gallery.dataset.hoverGalleryIndex = String(index);
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      });

      gallery.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerType !== 'mouse') return;
          if (!window.matchMedia('(min-width: 750px) and (pointer: fine)').matches) return;

          const dotCount = gallery.querySelectorAll('[data-hover-gallery-dot]').length;
          if (dotCount < 2) return;

          const bounds = gallery.getBoundingClientRect();
          const position = Math.min(Math.max((event.clientX - bounds.left) / bounds.width, 0), 0.9999);
          selectImage(Math.floor(position * dotCount));
        },
        { passive: true }
      );

      gallery.addEventListener(
        'pointerleave',
        (event) => {
          if (event.pointerType === 'mouse') selectImage(0);
        },
        { passive: true }
      );
    });
  };

  initializeProductCardHoverGalleries();

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductCardHoverGalleries(event.target);
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initializeProductCardHoverGalleries(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
